@use '@fukuri-admins/ui/layout' as *;

.link {
  color: text('Link');
  text-decoration: none;
}
